import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import TransactionMenu from './TransactionMenu';

const TransactionItem = ({ transaction, onUpdate, onDelete }) => {
  const isExpense = transaction.type === 'expense';
  const amount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(transaction.amount);

  return (
    <div
      className="flex items-center justify-between p-4 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-colors"
      data-testid={`transaction-${transaction.id}`}
    >
      <div className="flex items-center space-x-4">
        <div
          className={`p-2 rounded-lg ${
            isExpense ? 'bg-red-500/20 text-red-400' : 'bg-green-500/20 text-green-400'
          }`}
        >
          {isExpense ? (
            <ArrowDownRight className="w-5 h-5" />
          ) : (
            <ArrowUpRight className="w-5 h-5" />
          )}
        </div>
        <div>
          <p className="font-medium text-white">
            {transaction.merchant || transaction.description || transaction.category}
          </p>
          <p className="text-sm text-muted-foreground">
            {transaction.category} • {transaction.date}
          </p>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <p
          className={`text-lg font-mono font-bold ${
            isExpense ? 'text-red-400' : 'text-green-400'
          }`}
        >
          {isExpense ? '-' : '+'}{amount}
        </p>
        <TransactionMenu
          transaction={transaction}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      </div>
    </div>
  );
};

export default TransactionItem;
